<template>
  <div class="alliance-wrap">
    <div class="bg_wrap">
      <div class="left_array" @click="goBack">
        <img src="../../assets/images/winterGame/leftArrow.png" alt="" srcset="">
      </div>
      <div class="alliance">
        <div v-if="matchStatus.allianceType != 0" class="ala_title">
          {{ matchStatus.allianceType == 1 ? "萌新" : "老将" }}战队，你好
        </div>
        <!--未添加-->
        <template v-if="matchStatus.allianceStatus == 0">
          <div class="ala_info not-add">
            <p class="judge-team">请填写与你结盟的{{ matchStatus.allianceType == 1 ? '老' : '新' }}战队经销商ID</p>
            <p>匹配成功后，你们将成为结盟战队</p>
          </div>
          <div class="input-agent">
            <input v-model="agentId" placeholder="请输入与你结盟的老战队经销商ID" class="input-item">
          </div>
        </template>
        <!--未报名-->
        <template v-if="matchStatus.allianceStatus == 1">
          <div class="ala_info">
            <p >你已填写了以下经销商为你的结盟战队</p>
            <p>{{ matchStatus.allianceCampusName }}({{ matchStatus.allianceCampusId }})</p>
          </div>
        </template>
        <!--未结盟-->
        <template v-if="matchStatus.allianceStatus == 2">
          <div class="ala_info">
            <p>你已填写了以下经销商为你的结盟战队</p>
            <p>{{ matchStatus.allianceCampusName }}({{ matchStatus.allianceCampusId }})</p>
          </div>
        </template>
        <!--已结盟-->
        <template v-if="matchStatus.allianceStatus == 3">
          <div class="ala_info">
            <p>你已填写了以下经销商为你的结盟战队</p>
            <p>{{ matchStatus.allianceCampusName }}({{ matchStatus.allianceCampusId }})</p>
          </div>
        </template>
      </div>
      <template v-if="matchStatus.allianceStatus == 0">
        <a class="submit-btn" @click="submit">提 交</a>
      </template>
      <template v-if="matchStatus.allianceStatus == 1">
        <div class="result-icon">
          <img src="../../assets/images/winterGame/weibaoming.png">
        </div>
      </template>
      <template v-if="matchStatus.allianceStatus == 2">
        <div class="result-icon">
          <img src="../../assets/images/winterGame/weijiemeng.png">
        </div>
      </template>
      <template v-if="matchStatus.allianceStatus == 3">
        <div class="result-icon">
          <img src="../../assets/images/winterGame/yijiemeng.png">
        </div>
      </template>
    </div>
    <!--确认弹框-->
    <van-dialog v-model="showConfirm"  
      className="confirm-dialog" 
      confirmButtonColor="#58ABF6"
      @confirm="confirmAlliance"
      title="结盟战队确认" 
      show-cancel-button>
      <div class="confirm-content">
        <p class="confirm-text">确认以下经销商的战队为你的结盟战队</p>
        <p class="agent-info">{{ campusName  }}({{ agentId }})</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";
import { queryAllianceStatus, saveCampusAlliance, checkCampusAlliance } from "../../api/winterGame";

export default {
  data() {
    return {
      showConfirm: false,
      agentId: '',
      seasonTagId: '',
      campusId: '',
      campusName: '',
      matchStatus: {
        allianceStatus: -1,
        allianceType: 0,
        allianceCampusId: '',
        allianceCampusName: '',
      },
    };
  },
  mounted() {
    this.queryAllianceStatus();
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async queryAllianceStatus() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.campusId = userInfoId.campusId;
      } else {
        Toast("找不到参赛信息");
      }
      if (userInfoId) {
        this.seasonTagId = JSON.parse(localStorage.getItem("pkParams")).seasonId || '';
      } else {
        Toast("找不到参赛信息");
      }
      queryAllianceStatus({
        param: {
          campusId: this.campusId,
          seasonTagId: this.seasonTagId,
        }
      }).then(res => {
        if (res.code == 0) {
          this.matchStatus = res.data;
        }
      })
    },
    // 提交
    submit() {
      if (this.agentId == "") {
        Toast('请输入与你结盟的战队经销商ID');
      } else {
        checkCampusAlliance({
          param: {
            campusId: this.campusId,
            seasonTagId: this.seasonTagId,
            allianceCampusId: this.agentId
          },
        }).then(res => {
          if (res.code == 0) {
            this.showConfirm = true;
            this.campusName = res.data;
          } else {
            Toast(res.message || '提交失败');
          }
        })
      }
    },
    // 确认结盟
    confirmAlliance() {
      saveCampusAlliance({
        param: {
          campusId: this.campusId,
          seasonTagId: this.seasonTagId,
          allianceCampusId: this.agentId
        },
      }).then(res => {
        if (res.code == 0) {
          Toast('结盟成功');
          this.showConfirm = false;
          this.queryAllianceStatus();
        } else {
          Toast(res.message || '结盟失败');
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.alliance-wrap {
  width: 750px;
  height: 100vh;
  background-color: #ff0000;

  .left_array {
    position: absolute;
    width: 80px;
    height: 80px;
    top: 22px;
    left: 32px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .bg_wrap {
    width: 750px;
    height: 1448px;
    background: url(../../assets/images/winterGame/alliance_bg.png);
    background-size: contain;
    position: relative;

    .alliance {
      position: absolute;
      width: 600px;
      height: 450px;
      left: 50%;
      margin-left: -300px;
      bottom: 0px;
      text-align: center;
      .ala_title {
        height: 56px;
        font-size: 40px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #323232;
        line-height: 56px;
      }
      .ala_info {
        width: 580px;
        margin: 18px auto;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #323232;
        p {
          margin: 0;
          padding: 0;
          &.judge-team {
            margin-bottom: 10px;
          }
        }
        &.not-add {
          width: 580px;
        }
      }
      .input-agent {
        margin-top: 12px;
        .input-item {
          width: 526px;
          height: 72px;
          background: #D8D8D8;
          border-radius: 16px;
          border: 1px solid #E6E6E6;
          font-size: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          text-align: center;
        }
      }
    }
    .submit-btn {
      position: absolute;
      width: 600px;
      height: 96px;
      left: 50%;
      bottom: 90px;
      margin-left: -300px;
      background: #1D00FF;
      border-radius: 57px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 48px;
      font-family: Alibaba-PuHuiTi, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
    }
    .result-icon {
      position: absolute;
      width: 186px;
      height: 106px;
      right: 120px;
      bottom: 180px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.confirm-dialog {
  .confirm-content {
    p {
      margin: 0;
      padding: 0;
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #323232;
      line-height: 56px;
      text-align: center;
      &.confirm-text {
        margin-top: 16px;
      }
      &.agent-info {
        margin-bottom: 64px;
      }
    }
  }
}
</style>
